
import React from "react";
import { FilterX } from "lucide-react";
import { Button } from "@/components/ui/button";

interface NoFilteredBikesAlertProps {
  onClearFilter: () => void;
}

const NoFilteredBikesAlert: React.FC<NoFilteredBikesAlertProps> = ({ onClearFilter }) => {
  return (
    <div className="mt-4 rounded-md border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-center">
        <FilterX className="h-5 w-5 text-amber-600" />
        <span className="ml-2 text-amber-800">No bikes match the current filter.</span>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={onClearFilter}
          className="ml-auto text-amber-600 hover:bg-amber-100 hover:text-amber-700"
        >
          Clear Filter
        </Button>
      </div>
    </div>
  );
};

export default NoFilteredBikesAlert;
